import { render, staticRenderFns } from "./board.vue?vue&type=template&id=4ed5ea62&scoped=true"
import script from "./board.vue?vue&type=script&lang=js"
export * from "./board.vue?vue&type=script&lang=js"
import style0 from "./board.vue?vue&type=style&index=0&id=4ed5ea62&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed5ea62",
  null
  
)

export default component.exports